import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import { VIcon } from 'vuetify/lib';

@Component({
  name: 'BackButton',
})
export default class BackButton extends Vue {
  @Prop({type: String, default: 'back'}) public readonly name!: string;

  public hover: boolean = false;

  get isDisabled() {
    return !history.length;
  }

  get icon() {
    return this.isDisabled
      ? '$vuetify.icons.back_button_arrow_disabled'
      : this.hover
        ? '$vuetify.icons.back_button_arrow_hover'
        : '$vuetify.icons.back_button_arrow';
  }

  get color() {
    return this.hover ? {'dark-gray-op80': true } : {'dark-gray-op60': true };
  }

  private render(createElement: CreateElement): VNode {
    const button = createElement('button', {
      domProps: {
        disabled: this.isDisabled,
      },
      on: {
        click: () => this.$router.go(-1),
        mouseover: () => this.hover = true,
        mouseleave: () => this.hover = false,
      },
      class: {
        'flex-center': true,
        p6: true,
        ...this.color,
      },
    },
    [
      createElement(VIcon, {
        style: {
          cursor: 'pointer',
          'margin-right': '7.5px',
        },
      }, [this.icon]),
      this.name,
    ]);

    return createElement('div', [button]);
  }
}
